import { useRef } from "react";

type Props = {
  onFiles: (files: File[]) => void;
};

export function UploadZone({ onFiles }: Props) {
  const fileInput = useRef<HTMLInputElement | null>(null);
  const cameraInput = useRef<HTMLInputElement | null>(null);

  const handleFiles = (list: FileList | null) => {
    if (!list || list.length === 0) return;
    const files: File[] = [];
    for (const f of list) files.push(f);
    onFiles(files);
  };

  return (
    <div className="rounded-lg border-2 border-dashed border-ink/30 p-6 text-center">
      <p className="text-sm text-ink/70">Tiputa kuvat/videot tähän tai käytä allaolevaa painiketta.</p>
      <div className="mt-3 flex flex-wrap items-center justify-center gap-2">
        <button
          type="button"
          className="rounded bg-ink px-4 py-2 text-sm font-medium text-white"
          onClick={() => fileInput.current?.click()}
        >
          Lähetä kuvia
        </button>
        <button
          type="button"
          className="rounded border border-ink/30 px-4 py-2 text-sm font-medium md:hidden"
          onClick={() => cameraInput.current?.click()}
        >
          Ota kuva tai video
        </button>
      </div>
      <input
        ref={fileInput}
        type="file"
        multiple
        accept="image/*,video/*"
        className="hidden"
        onChange={(e) => {
          handleFiles(e.target.files);
          e.target.value = "";
        }}
      />
      <input
        ref={cameraInput}
        type="file"
        accept="image/*,video/*"
        capture="environment"
        className="hidden"
        onChange={(e) => {
          handleFiles(e.target.files);
          e.target.value = "";
        }}
      />
    </div>
  );
}
